import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fbe330c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = { class: "titlebar-actions-secondary" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Duplicar")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "titlebar-actions-primary" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "ui-card" }
const _hoisted_14 = { class: "ui-card-body" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Detalhe"
}, "Detalhe", -1))
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Possui Variações"
}, "Possui Variações", -1))
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-20" }, null, -1))
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Nova variação")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-21 ui-cell" }, " Variação "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1))
const _hoisted_38 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_39 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-21 ui-cell ui-ellipsis",
  "data-title": "Variação"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center",
  "data-title": "Ações"
}
const _hoisted_42 = { class: "ui-actions" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_combo_categoria = _resolveComponent("combo-categoria")!
  const _component_combo_marca = _resolveComponent("combo-marca")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_produto_imagens = _resolveComponent("produto-imagens")!
  const _component_produto_codigos = _resolveComponent("produto-codigos")!
  const _component_produto_precos = _resolveComponent("produto-precos")!
  const _component_produto_estoque = _resolveComponent("produto-estoque")!
  const _component_produto_peso_medidas = _resolveComponent("produto-peso-medidas")!
  const _component_produto_simulador_frete = _resolveComponent("produto-simulador-frete")!
  const _component_produto_nova_variacao = _resolveComponent("produto-nova-variacao")!
  const _component_produto_editar_variacao = _resolveComponent("produto-editar-variacao")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_card = _resolveComponent("card")!
  const _component_produto_caracteristicas = _resolveComponent("produto-caracteristicas")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_produto_abas_informativas = _resolveComponent("produto-abas-informativas")!
  const _component_produto_relacionados = _resolveComponent("produto-relacionados")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_seo = _resolveComponent("seo")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          ((_ctx.state.produto.codigo > 0))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ui-button -secondary",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.duplicar()))
              }, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_12)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.produto.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.produto.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_18,
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Utilize este campo para informar a unidade ou alguma outra informação que vai ficar em evidência na apresentação do produto."
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ui-icone-informacao",
                              nome: "informacao-campo"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.produto.detalhe) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.produto.detalhe]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Categorias" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_categoria, {
                          multiplaSelecao: true,
                          codigos: _ctx.state.categoriasSelecionadas,
                          "onUpdate:codigos": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.categoriasSelecionadas) = $event))
                        }, null, 8, ["codigos"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Marca" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_marca, {
                          codigo: _ctx.state.produto.codigoMarca,
                          "onUpdate:codigo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.produto.codigoMarca) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, { label: "Destaque" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.produto.destaque,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.produto.destaque) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Não")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sim")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_a_form_item, null, {
                      label: _withCtx(() => [
                        _hoisted_25,
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Permite que você controle as variações do produto como: tamanho, cores e outras características com preço e estoque específico para cada variação."
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ui-icone-informacao",
                              nome: "informacao-campo"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.produto.possuiVariacao,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.produto.possuiVariacao) = $event)),
                          "button-style": "solid",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.estratagiaVariacoes()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Não")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sim")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.produto.status,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.produto.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativo")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativo")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Descrição")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.produto.descricao,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.produto.descricao) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                (!_ctx.state.produto.possuiVariacao)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_produto_imagens, {
                        imagens: _ctx.state.produto.definicoes[0].imagens,
                        "onUpdate:imagens": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.produto.definicoes[0].imagens) = $event))
                      }, null, 8, ["imagens"]),
                      _createVNode(_component_produto_codigos, {
                        sku: _ctx.state.produto.definicoes[0].sku,
                        "onUpdate:sku": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.produto.definicoes[0].sku) = $event)),
                        codigoBarras: _ctx.state.produto.definicoes[0].codigoBarras,
                        "onUpdate:codigoBarras": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.produto.definicoes[0].codigoBarras) = $event)),
                        codigoErp: _ctx.state.produto.definicoes[0].codigoErp,
                        "onUpdate:codigoErp": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.produto.definicoes[0].codigoErp) = $event))
                      }, null, 8, ["sku", "codigoBarras", "codigoErp"]),
                      _createVNode(_component_produto_precos, {
                        precos: _ctx.state.produto.definicoes[0].precos,
                        "onUpdate:precos": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.produto.definicoes[0].precos) = $event)),
                        "precos-por-quantidades": _ctx.state.produto.definicoes[0].precosPorQuantidades,
                        "onUpdate:precosPorQuantidades": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.produto.definicoes[0].precosPorQuantidades) = $event))
                      }, null, 8, ["precos", "precos-por-quantidades"]),
                      _createVNode(_component_produto_estoque, {
                        gerenciarEstoque: _ctx.state.produto.definicoes[0].gerenciarEstoque,
                        "onUpdate:gerenciarEstoque": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.produto.definicoes[0].gerenciarEstoque) = $event)),
                        disponibilidade: _ctx.state.produto.definicoes[0].disponibilidade,
                        "onUpdate:disponibilidade": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.produto.definicoes[0].disponibilidade) = $event)),
                        regraSemEstoque: _ctx.state.produto.definicoes[0].regraSemEstoque,
                        "onUpdate:regraSemEstoque": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.produto.definicoes[0].regraSemEstoque) = $event)),
                        quantidadeEstoque: _ctx.state.produto.definicoes[0].quantidadeEstoque,
                        "onUpdate:quantidadeEstoque": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.produto.definicoes[0].quantidadeEstoque) = $event)),
                        venderMultiplos: _ctx.state.produto.definicoes[0].venderMultiplos,
                        "onUpdate:venderMultiplos": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.produto.definicoes[0].venderMultiplos) = $event))
                      }, null, 8, ["gerenciarEstoque", "disponibilidade", "regraSemEstoque", "quantidadeEstoque", "venderMultiplos"]),
                      _createVNode(_component_produto_peso_medidas, {
                        peso: _ctx.state.produto.definicoes[0].peso,
                        "onUpdate:peso": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.produto.definicoes[0].peso) = $event)),
                        altura: _ctx.state.produto.definicoes[0].altura,
                        "onUpdate:altura": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.produto.definicoes[0].altura) = $event)),
                        largura: _ctx.state.produto.definicoes[0].largura,
                        "onUpdate:largura": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.produto.definicoes[0].largura) = $event)),
                        comprimento: _ctx.state.produto.definicoes[0].comprimento,
                        "onUpdate:comprimento": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.produto.definicoes[0].comprimento) = $event))
                      }, null, 8, ["peso", "altura", "largura", "comprimento"]),
                      _withDirectives(_createVNode(_component_produto_simulador_frete, {
                        codigoProduto: _ctx.state.produto.codigo,
                        codigoProdutoDefinicao: _ctx.state.produto.definicoes[0].codigo
                      }, null, 8, ["codigoProduto", "codigoProdutoDefinicao"]), [
                        [_vShow, (_ctx.state.produto.codigo > 0 && _ctx.state.produto.definicoes[0].codigo > 0)]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.produto.possuiVariacao && _ctx.state.caracteristicasCadastradas.length >0))
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 1,
                      titulo: "Variações"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.state.caracteristicasCadastradas.length >0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("button", {
                                    class: "ui-button ui-full -primary",
                                    type: "button",
                                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.adicionarNovaVariacao()))
                                  }, _hoisted_35)
                                ])
                              ]),
                              _createVNode(_component_produto_nova_variacao, {
                                ref: "refNovaVariacao",
                                definicoesProdutos: _ctx.state.produto.definicoes,
                                "onUpdate:definicoesProdutos": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.produto.definicoes) = $event)),
                                caracteristicasCadastradas: _ctx.state.caracteristicasCadastradas
                              }, null, 8, ["definicoesProdutos", "caracteristicasCadastradas"]),
                              _createVNode(_component_produto_editar_variacao, {
                                ref: "refEditarVariacao",
                                descricaoProduto: _ctx.state.produto.nome,
                                definicoesProdutos: _ctx.state.produto.definicoes,
                                "onUpdate:definicoesProdutos": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.produto.definicoes) = $event)),
                                visivel: _ctx.state.apresentarModalVariacao,
                                "onUpdate:visivel": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.apresentarModalVariacao) = $event)),
                                caracteristicasCadastradas: _ctx.state.caracteristicasCadastradas
                              }, null, 8, ["descricaoProduto", "definicoesProdutos", "visivel", "caracteristicasCadastradas"]),
                              (_ctx.state.produto.definicoes.length <= 0)
                                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                    key: 0,
                                    mensagem: "Nenhuma variação foi criada ainda"
                                  }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _hoisted_37,
                                    _createElementVNode("div", _hoisted_38, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.produto.definicoes, (definicaoProduto, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "ant-row ui-row"
                                        }, [
                                          _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("a", {
                                              class: "ui-link",
                                              onClick: ($event: any) => (_ctx.editarVariacao(definicaoProduto, index))
                                            }, _toDisplayString(_ctx.montarVariacaoProduto(definicaoProduto)), 9, _hoisted_40)
                                          ]),
                                          _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("div", _hoisted_42, [
                                              _createVNode(_component_a_tooltip, { title: "Editar Variação" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    class: "ui-action",
                                                    onClick: ($event: any) => (_ctx.editarVariacao(definicaoProduto, index))
                                                  }, [
                                                    _createVNode(_component_icone, { nome: "editar" })
                                                  ], 8, _hoisted_43)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_a_tooltip, { title: "Deletar Variação" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("a", {
                                                    class: "ui-action",
                                                    onClick: ($event: any) => (_ctx.excluirVariacao(index))
                                                  }, [
                                                    _createVNode(_component_icone, { nome: "excluir" })
                                                  ], 8, _hoisted_44)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                            ]))
                          : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                              key: 1,
                              mensagem: "Nenhuma característica localizada ou cadastrada"
                            }))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_collapse, { accordion: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, {
                      key: "1",
                      header: "Características"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_produto_caracteristicas, {
                          caracteristicas: _ctx.state.produto.caracteristicas,
                          "onUpdate:caracteristicas": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.produto.caracteristicas) = $event)),
                          caracteristicasCadastradas: _ctx.state.caracteristicasCadastradas
                        }, null, 8, ["caracteristicas", "caracteristicasCadastradas"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_collapse_panel, {
                      key: "2",
                      header: "Abas Informativas"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_produto_abas_informativas, {
                          abasInformativas: _ctx.state.produto.abasInformativas,
                          "onUpdate:abasInformativas": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.produto.abasInformativas) = $event))
                        }, null, 8, ["abasInformativas"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_collapse_panel, {
                      key: "3",
                      header: "Produtos Relacionados"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_produto_relacionados, {
                          produtosRelacionados: _ctx.state.produto.produtosRelacionados,
                          "onUpdate:produtosRelacionados": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.produto.produtosRelacionados) = $event)),
                          codigoProduto: _ctx.state.produto.codigo
                        }, null, 8, ["produtosRelacionados", "codigoProduto"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_seo, {
              tituloExemplo: _ctx.state.produto.nome,
              estrutura: _ctx.state.produto.estrutura,
              "onUpdate:estrutura": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.produto.estrutura) = $event))
            }, null, 8, ["tituloExemplo", "estrutura"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}